<!-- =========================================================================================
  File Name: UserEdit.vue
  Description: User Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-edit">

    <vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
      <span>User record with id: {{ $route.params.userId }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'page-user-list'}" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert>

    <!-- <vx-card title="Configurações"> -->

      <div class="vx-row mb-3" style="margin-top: -10px!important;">
        <div class="vx-col w-full">
          <div class="mt-8 flex flex-wrap items-center justify-end">
            <vs-button class="ml-auto mt-2" color="warning" type="filled" icon-pack="feather" icon="icon-rotate-ccw" @click="confirmReset">{{ $t('APPLICATION.SETTINGS.restore_default') }}</vs-button>
            <vs-button class="ml-4 mt-2" icon-pack="feather" icon="icon-save" @click="save_changes">{{ $t('APPLICATION.SETTINGS.save_changes') }}</vs-button>
          </div>
        </div>
      </div>

      <div class="vx-row match-height">
          <!-- <div class="vx-col sm:w-1/2 w-full"> -->
            <vx-card class="vx-col sm:w-1/2 w-full mb-base" :title="$t('APPLICATION.SETTINGS.general')">
              <div class="vx-row">
                <div class="vx-col md:w-1/2">
                  <div data-v-13a23bd0="" v-if="viewMode && generalData.favicon !== null">
                    <label class="vs-input--label"> Favicon </label>
                    <div data-v-13a23bd0="" class="con-upload">
                      <div class="con-img-upload">
                        <div class="img-upload">
                          <button type="button" class="btn-x-file" @click="closeImage"><i translate="translate" class="material-icons notranslate">clear</i></button>
                          <img :src="generalData.favicon" style="max-width: 100%; max-height: none;" @click="clickImage(generalData.favicon)">
                        </div>
                        <div class="con-input-upload disabled-upload">
                          <input type="file" accept="image/*" disabled="disabled"><span class="text-input">{{ $t('APPLICATION.SETTINGS.upload_file') }}</span>
                          <span class="input-progress" style="width: 0%;"></span>
                          <button type="button" disabled title="Upload" class="btn-upload-all vs-upload--button-upload"><i translate="translate" class="material-icons notranslate">cloud_upload</i></button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- v-else-if="(field.type_id === 21 && !viewMode[field.hash]) || (field.type_id === 21 && fieldModel[field.hash] === null)" -->
                  <div v-else-if="!viewMode && generalData.favicon === null">
                    <label class="vs-input--label"> Favicon</label>
                    <vs-upload text="Enviar Arquivo" :fileName="'file'" automatic :action="$store.state.auth.api_url + '/save-image'" :accept="'image/*'" :data="{application_token: $store.state.auth.app_token,session_token: $store.state.auth.token}" limit="1" single-upload @on-success="successUploadFavicon($event)" />
                  </div>
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full">
                  <vs-input class="w-full mt-4" :label="$t('APPLICATION.SETTINGS.title_of_browser_tab')" v-model="generalData.tabTitle" @input="setTabTitle" name="web-tab" />
                  <span class="text-danger text-sm"  v-show="errors.has('username')">{{ errors.first('username') }}</span>

                  <vs-input class="w-full mt-4" :label="$t('APPLICATION.SETTINGS.welcome_message_on_telegram')"  v-model="generalData.telegramWelcomeMessage" @input="setTelegramWelcomeMessage" name="telegram-user-welcome-message" />
                  <span class="text-danger text-sm"  v-show="errors.has('username')">{{ errors.first('username') }}</span>

                  <vs-input class="w-full mt-4" :label="$t('APPLICATION.SETTINGS.api_delegator_url')" v-model="generalData.apiDelegator" @input="setApiDelegator" name="api-delegator" />
                  <!-- <span class="text-danger text-sm"  v-show="errors.has('username')">{{ errors.first('username') }}</span> -->
                </div>

                <div class="vx-col md:w-1/2 w-full" @click="clickRefreshToken">

                  <vs-input class="w-full mt-4" :label="$t('APPLICATION.SETTINGS.footer')" v-model="generalData.footer" @input="setFooter" name="footer" />
                  <span class="text-danger text-sm"  v-show="errors.has('username')">{{ errors.first('username') }}</span>

                  <vs-input class="w-full mt-4 mb-4" :label="$t('APPLICATION.SETTINGS.telegram_bot_token')" v-model="generalData.telegramBotToken" @input="setTelegramBotToken" name="telegram-bot-token" />
                  <span class="text-danger text-sm"  v-show="errors.has('username')">{{ errors.first('username') }}</span>

                  <!-- <vs-input class="w-full mt-4" label="API Integration Token" v-model="generalData.apiIntegrationToken" @input="setApiIntegrationToken" name="api-integration-token" /> -->
                  <label class="vs-input--label mt-4">{{ $t('APPLICATION.SETTINGS.api_integration_token') }}</label>
                  <vs-input  class="w-full" icon-pack="feather" icon="icon-refresh-cw" icon-after vs-icon-after="true" v-model="generalData.apiIntegrationToken" @input="setApiIntegrationToken"/>

                </div>
              </div>

            <div class="vx-row">
              <div class="vx-col md:w-1/4 w-full">
                <ul class="con-s w-full mt-4">
                  <li>
                    <label class="vs-input--label">{{ $t('APPLICATION.SETTINGS.simultaneous_sessions') }}</label>
                    <vs-switch class="mt-2" v-model="generalData.simultaneousSessions" @input="setUsersCanSimultaneousSessions" />
                  </li>
                </ul>
              </div>
              <div class="vx-col md:w-1/4 w-full" style="margin-left: -15%!important;">
                <ul class="con-s w-full mt-4" style="margin-left: 70px!important;">
                  <li>
                    <label class="vs-input--label">{{ $t('APPLICATION.SETTINGS.logical_deletion') }}</label>
                    <vs-switch class="mt-2" v-model="generalData.logicalExclusion" @input="setLogicalExclusion" />
                  </li>
                </ul>
              </div>
            </div>
          </vx-card>
        <!-- </div> -->
      <!-- <div > -->
        <vx-card class="vx-col sm:w-1/2 w-full mb-base" :title="$t('APPLICATION.SETTINGS.outgoing_servers')">

            <div class="vx-row">

      <!-- Col 1 -->
              <div class="vx-col w-full md:w-1/2">
                <!-- <vs-input
                  class="w-full"
                  v-model="serverData.emailSenderDriverTypeId"
                  label="Protocolo"
                  @input="setTwitter"
                  icon-no-border
                  name="twitter" /> -->

                  <label for="" class="vs-input--label">{{ $t('APPLICATION.SETTINGS.protocol')  }}</label>
                  <v-select :options="driverOptions" label="name" @input="setEmailProtocol" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="serverData.emailSenderDriverTypeId" class="w-full"/>
                  <!-- class="mb-4 md:mb-0"  -->

                  <vs-input
                  class="w-full mt-4"
                  v-model="serverData.emailSenderPort"
                  :label="$t('APPLICATION.SETTINGS.email_server_port')"
                  @input="setEmailPort"
                  icon-no-border
                  name="facebook" />

                  <vs-input
                  class="w-full mt-4"
                  v-model="serverData.emailSenderFromName"
                  :label="$t('APPLICATION.SETTINGS.sender_name')"
                  @input="setEmailFromName"
                  icon-no-border
                  name="instagram" />

                  <vs-input
                  class="w-full mt-4"
                  v-model="serverData.emailSenderPassword"
                  :label="$t('APPLICATION.SETTINGS.authentication_password')"
                  @input="setEmailPassword"
                  icon-no-border
                  name="slack" />

              </div>

              <!-- Col 2 -->
              <div class="vx-col w-full md:w-1/2">

                <vs-input
                    class="w-full"
                    v-model="serverData.emailSenderHost"
                    :label="$t('APPLICATION.SETTINGS.email_server_host')"
                    @input="setEmailHost"
                    icon-no-border
                    name="twitter" />

                <vs-input
                  class="w-full mt-4"
                  v-model="serverData.emailSenderFromAddress"
                  :label="$t('APPLICATION.SETTINGS.sender_email')"
                  @input="setEmailFromAddress"
                  icon-no-border
                  name="github" />

                <vs-input
                  class="w-full mt-4"
                  v-model="serverData.emailSenderUsername"
                  :label="$t('APPLICATION.SETTINGS.authentication_email')"
                  @input="setEmailUsername"
                  icon-no-border
                  name="codepen" />

              </div>
            </div>
          </vx-card>
      <!-- </div> -->
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card title="Login">
          <div class="vx-row">
            <div class="vx-col w-full md:w-1/2">
              <div data-v-13a23bd0="" v-if="backgroundViewMode && loginData.backgroundImage !== null">
                <label class="vs-input--label"> {{ $t('APPLICATION.SETTINGS.background_image') }}</label>
                <div data-v-13a23bd0="" class="con-upload">
                  <div class="con-img-upload">
                    <div class="img-upload">
                      <button type="button" class="btn-x-file" @click="closeImageBackground"><i translate="translate" class="material-icons notranslate">clear</i></button>
                      <img :src="loginData.backgroundImage" style="max-width: 100%; max-height: none;" @click="clickImageBackground(loginData.backgroundImage)">
                    </div>
                    <div class="con-input-upload disabled-upload">
                      <input type="file" accept="image/*" disabled="disabled"><span class="text-input">{{ $t('APPLICATION.SETTINGS.upload_file') }}</span>
                      <span class="input-progress" style="width: 0%;"></span>
                      <button type="button" disabled title="Upload" class="btn-upload-all vs-upload--button-upload"><i translate="translate" class="material-icons notranslate">cloud_upload</i></button>
                    </div>
                  </div>
                </div>
              </div>

              <div v-else-if="!backgroundViewMode && loginData.backgroundImage === null">
                <label class="vs-input--label">{{ $t('APPLICATION.SETTINGS.background_image') }}</label>
                <vs-upload text="Enviar Arquivo" :fileName="'file'" automatic :action="$store.state.auth.api_url + '/save-image'" :accept="'image/*'" :data="{application_token: $store.state.auth.app_token,session_token: $store.state.auth.token}" limit="1" single-upload @on-success="successUpload($event, 1)" />
              </div>
            </div>
            <div class="vx-col w-full md:w-1/2">
              <div data-v-13a23bd0="" v-if="cardImageViewMode && loginData.cardImage !== null">
                <label class="vs-input--label">{{ $t('APPLICATION.SETTINGS.card_image') }}</label>
                <div data-v-13a23bd0="" class="con-upload">
                  <div class="con-img-upload">
                    <div class="img-upload">
                      <button type="button" class="btn-x-file" @click="closeImageCardImage"><i translate="translate" class="material-icons notranslate">clear</i></button>
                      <img :src="loginData.cardImage" style="max-width: 100%; max-height: none;" @click="clickImageCardImage(loginData.cardImage)">
                    </div>
                    <div class="con-input-upload disabled-upload">
                      <input type="file" accept="image/*" disabled="disabled"><span class="text-input">{{ $t('APPLICATION.SETTINGS.upload_file') }}</span>
                      <span class="input-progress" style="width: 0%;"></span>
                      <button type="button" disabled title="Upload" class="btn-upload-all vs-upload--button-upload"><i translate="translate" class="material-icons notranslate">cloud_upload</i></button>
                    </div>
                  </div>
                </div>
              </div>

              <div v-else-if="!cardImageViewMode && loginData.cardImage === null">
                <label class="vs-input--label">{{ $t('APPLICATION.SETTINGS.card_image') }}</label>
                <vs-upload text="Enviar Arquivo" :fileName="'file'" automatic :action="$store.state.auth.api_url + '/save-image'" :accept="'image/*'" :data="{application_token: $store.state.auth.app_token,session_token: $store.state.auth.token}" limit="1" single-upload @on-success="successUpload($event, 2)" />
              </div>
            </div>
            <div class="vx-col w-full md:w-1/2">
              <div data-v-13a23bd0="" v-if="cardLogoViewMode && loginData.cardLogo !== null">
                <label class="vs-input--label"> {{ $t('APPLICATION.SETTINGS.card_logo') }}</label>
                <div data-v-13a23bd0="" class="con-upload">
                  <div class="con-img-upload">
                    <div class="img-upload">
                      <button type="button" class="btn-x-file" @click="closeImageCardLogo"><i translate="translate" class="material-icons notranslate">clear</i></button>
                      <img :src="loginData.cardLogo" style="max-width: 100%; max-height: none;" @click="clickImageCardLogo(loginData.cardLogo)">
                    </div>
                    <div class="con-input-upload disabled-upload">
                      <input type="file" accept="image/*" disabled="disabled"><span class="text-input">{{ $t('APPLICATION.SETTINGS.upload_file') }}</span>
                      <span class="input-progress" style="width: 0%;"></span>
                      <button type="button" disabled title="Upload" class="btn-upload-all vs-upload--button-upload"><i translate="translate" class="material-icons notranslate">cloud_upload</i></button>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else-if="!cardLogoViewMode && loginData.cardLogo === null">
                <label class="vs-input--label">{{ $t('APPLICATION.SETTINGS.card_logo') }}</label>
                <vs-upload text="Enviar Arquivo" :fileName="'file'" automatic :action="$store.state.auth.api_url + '/save-image'" :accept="'image/*'" :data="{application_token: $store.state.auth.app_token,session_token: $store.state.auth.token}" limit="1" single-upload @on-success="successUpload($event, 3)" />
              </div>
            </div>
          </div>
        <div class="vx-row">
          <div class="vx-col w-full md:w-1/2">

            <!-- Col Content -->
            <div>
              {{ $t('APPLICATION.SETTINGS.user_field_label') }}
              <vs-input class="w-full mt-4" :label="$t('APPLICATION.SETTINGS.title_of_browser_tab')" v-model="loginData.tabName" @input="setTabName" name="address_line_1" />

              <vs-input class="w-full mt-4" :label="$t('APPLICATION.SETTINGS.user_field_label')" v-model="loginData.usernameLabel" @input="setUsernameLabel" name="address_line_2"/>

              <vs-input class="w-full mt-4" :label="$t('APPLICATION.SETTINGS.forgot_password_button_label')" v-model="loginData.forgotLabel" @input="setForgotLabel" name="address_line_2"/>

              <vs-input class="w-full mt-4" :label="$t('APPLICATION.SETTINGS.reset_password_form_button_label')" v-model="loginData.forgotPasswordButtonLabel" @input="setForgotPasswordButtonLabel" name="address_line_2"/>
            </div>

          </div>

          <!-- Address Col -->
          <div class="vx-col w-full md:w-1/2">

            <!-- Col Content -->
            <div>
              <vs-input class="w-full mt-4" :label="$t('APPLICATION.SETTINGS.card_title')" v-model="loginData.title" @input="setTitle" name="address_line_1" />

              <vs-input class="w-full mt-4" :label="$t('APPLICATION.SETTINGS.password_field_label')" v-model="loginData.passwordLabel" @input="setPasswordLabel" name="address_line_2"/>

              <vs-input class="w-full mt-4" :label="$t('APPLICATION.SETTINGS.reset_password_form_title')" v-model="loginData.forgotPasswordTitle" @input="setForgotPasswordTitle" name="address_line_2"/>

              <vs-input class="w-full mt-4" :label="$t('APPLICATION.SETTINGS.reset_password_email_field_label')" v-model="loginData.forgotPasswordEmailLabel" @input="setForgotPasswordEmailLabel" name="address_line_2"/>

            </div>
          </div>

          <div class="vx-col w-full md:w-1/2">

              <!-- Col Content -->
              <div>
                <vs-input class="w-full mt-4" :label="$t('APPLICATION.SETTINGS.submit_button_label')" v-model="loginData.submitLabel" @input="setSubmitLabel" name="address_line_2"/>
              </div>
          </div>
        </div>
      </vx-card>
      </div>
    </div>



      <!-- <div slot="no-body" class="tabs-container px-6 pt-6">

        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="Geral" icon-pack="feather" icon="icon-settings">
            <div class="tab-text">
              <general-tab class="mt-4" />
            </div>
          </vs-tab>
          <vs-tab label="Login" icon-pack="feather" icon="icon-log-in">
            <div class="tab-text">
              <login-tab class="mt-4" />
            </div>
          </vs-tab>
          <vs-tab label="Servidores de saída" icon-pack="feather" icon="icon-log-out">
            <div class="tab-text">
              <server-tab class="mt-4" />
            </div>
          </vs-tab>
        </vs-tabs>

      </div> -->

    <!-- </vx-card> -->
  </div>
</template>

<script>
import GeneralTab     from './ApplicationTabGeneral.vue'
import LoginTab from './ApplicationTabLogin.vue'
import ServerTab      from './ApplicationTabOutgoingServer.vue'
import vSelect from 'vue-select'
import { performFetch } from '../../helpers.js'

// Store Module
import moduleApplicationManagement from '@/store/application-management/moduleApplicationManagement.js'

export default {
  components: {
    GeneralTab,
    LoginTab,
    ServerTab,
    vSelect
  },
  data () {
    return {
      user_data: null,
      user_not_found: false,

      driverOptions: [
        {
          id: 1,
          name: 'SMTP'
        },
        {
          id: 2,
          name: 'IMAP'
        }
      ],

      serverData: {
        emailSenderDriverTypeId: {
          id: 1,
          name: 'SMTP'
        },
        emailSenderPort: '',
        emailSenderFromName: '',
        emailSenderHost: '',
        emailSenderFromAddress: '',
        emailSenderUsername: '',
        emailSenderPassword: ''
      },

      viewMode: true,

      backgroundViewMode: true,
      cardImageViewMode: true,
      cardLogoViewMode: true,

      generalData: {
        tabTitle: '',
        footer: '',
        telegramWelcomeMessage: '',
        telegramBotToken: '',
        simultaneousSessions: false,
        logicalExclusion: false,
        apiDelegator: '',
        apiIntegrationToken: ''
      },

      loginData: {
        backgroundImage: '',
        cardImage: '',
        cardLogo: '',
        tabName: '',
        title: '',
        subtitle: '',
        usernameLabel: '',
        passwordLabel: '',
        submitLabel: '',
        forgotLabel: '',
        forgotPasswordTitle: '',
        forgotPasswordEmailLabel: '',
        forgotPasswordButtonLabel: ''
      },

      /*
        This property is created for fetching latest data from API when tab is changed

        Please check it's watcher
      */
      activeTab: 0
    }
  },
  created() {

  },
  watch: {
    async activeTab () {

    }
  },
  mounted () {
    document.title = `${document.title.split(' | ')[0]  } | Perfil`

    document.querySelector('.icon-refresh-cw.icon-after').style.cursor = 'pointer'
  },
  methods: {
    clickRefreshToken(e) {

      if(e.srcElement.tagName === 'I' && e.srcElement.classList.contains('icon-refresh-cw')) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'primary',
          title: 'Confirmar Reset',
          text: this.$t('APPLICATION.SETTINGS.modal_alert_token_integration'),
          accept: this.refreshToken,
          acceptText: 'Resetar'
        })
      }
    },
    async refreshToken() {

      this.$vs.loading({ type: 'default' })

      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'refresh_application_integration_token',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
        command: 'refresh_application_integration_token',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token
        }
      })
        .then(async (response) => {
          if (response.status === 200) {
            response.json().then(async (responseData) => {

              this.$store.commit('applicationManagement/SET_API_INTEGRATION_TOKEN', responseData.data.api_token)

              setTimeout(() => {

                this.generalData.apiIntegrationToken = responseData.data.api_token

                this.$vs.notify({
                  title: this.$t('APPLICATION.SETTINGS.operation_completed'),
                  text: this.$t('APPLICATION.SETTINGS.modal_alert_token_integration_response'),
                  iconPack: 'feather',
                  icon: 'icon-check',
                  color: 'success'
                })

                this.$vs.loading.close()

              }, 300)

            })
          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            this.$vs.loading.close()
          }
        })
        .catch((e) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('APPLICATION.SETTINGS.operation_not_completed'),
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })

      this.rowHashToRefresh = ''

    },
    successUpload(event, type) {
      const responseData = JSON.parse(event.srcElement.response)

      if(type === 1) {
        // this.backgroundViewMode = !this.backgroundViewMode
        this.loginData.background = responseData.file_url
        this.$store.commit('applicationManagement/SET_BACKGROUND', responseData.file_url)
      } else if(type === 2) {
        this.cardImageViewMode = !this.cardImageViewMode
        this.loginData.cardImage = responseData.file_url
        this.$store.commit('applicationManagement/SET_CARD_IMAGE', responseData.file_url)
      } else {
        this.cardLogoViewMode = !this.cardLogoViewMode
        this.loginData.cardLogo = responseData.file_url
        this.$store.commit('applicationManagement/SET_CARD_LOGO', responseData.file_url)
      }
    },
    successUploadFavicon(event) {
      const responseData = JSON.parse(event.srcElement.response)

      this.generalData.favicon = responseData.file_url
      this.$store.commit('applicationManagement/SET_FAVICON', responseData.file_url)
    },
    confirmReset () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirmar',
        text: 'Você tem certeza que deseja restaurar as configurações para o padrão ?',
        accept: this.reset_changes,
        acceptText: 'Restaurar'
      })
    },
    reset_changes() {
      fetch(`${this.$store.state.auth.api_url}`, {
        method: 'POST', headers: {"Content-Type": "application/json"},
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          command: 'reset_application_settings',
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token
          }
        })
      })
        .then(async (response) => {
          this.$vs.loading.close()
          if (response.status === 200) {

            setTimeout(async () => {
              await this.fetch_application_data(this.$store.state.auth.token, this.$store.state.auth.app_token, this.$store.state.auth.api_url)

              this.backgroundViewMode = true
              this.cardImageViewMode = true
              this.cardLogoViewMode = true
              this.viewMode = true

              this.$vs.notify({
                title: 'Operação realizada!',
                text: 'Configurações restauradas para o padrão!',
                iconPack: 'feather',
                icon: 'icon-check',
                color: 'success'
              })
            }, 300)

          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Operação não realizada!',
              text: 'Ocorreu um erro ao buscar os módulos da aplicação!',
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'danger'
            })
          }
        })
        .catch((e) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Operação não realizada!',
            text: 'Ocorreu um erro ao buscar os módulos da aplicação!',
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    },
    validateForm() {

      if(this.generalData.apiDelegator !== '' && this.generalData.apiDelegator !== null) {
        let validUrl = false

        try {
          let url = new URL(this.generalData.apiDelegator)
          validUrl = true
        } catch(e) {
          //
        }

        if(!validUrl) {
          this.$vs.notify({
            title: 'Atenção!',
            text: 'O campo "API DELEGATOR" precisa ser uma URL válida!',
            iconPack: 'feather',
            icon: 'icon-info',
            color: 'warning'
          })

          return false
        }
      }

      return true

    },
    save_changes () {
      /* eslint-disable */
      // if (!this.validateForm) return

      if (!this.validateForm()) return

      this.$vs.loading({type: 'default'})

      this.$store.dispatch('applicationManagement/saveChanges', {apiUrl: this.$store.state.auth.api_url})
      .then(async (result) => {
        this.$vs.loading.close()

        this.$vs.notify({
            title: 'Operação Realizada!',
            text: `Dados alterados com sucesso!`,
            iconPack: 'feather',
            icon: 'icon-success-circle',
            color: 'success'
          })
      })
      .catch((err) => {
        this.$vs.loading.close()

        this.$vs.notify({
            title: 'Erro',
            text: err.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
        })
      })

      // Here will go your API call for updating data
      // You can get data in "this.data_local"

      /* eslint-enable */
    },
    closeImageCardLogo() {
      this.cardLogoViewMode = !this.cardLogoViewMode
      this.loginData.cardLogo = null
    },
    closeImageBackground() {
      this.backgroundViewMode = !this.backgroundViewMode
      this.loginData.backgroundImage = null
    },
    clickImageCardLogo(imagePayload) {
      const div = document.createElement('div')
      div.classList.add('view-upload')

      const img = document.createElement('img')

      img.setAttribute('src', imagePayload)

      div.appendChild(img)
      document.querySelector('body').prepend(div)
    },
    clickImageBackground(imagePayload) {
      const div = document.createElement('div')
      div.classList.add('view-upload')

      const img = document.createElement('img')

      img.setAttribute('src', imagePayload)

      div.appendChild(img)
      document.querySelector('body').prepend(div)
    },
    closeImageCardImage() {
      this.cardImageViewMode = !this.cardImageViewMode
      this.loginData.cardImage = null
    },
    closeImage() {
      this.viewMode = !this.viewMode
      this.generalData.favicon = null
    },
    setTabTitle (e) {
      this.$store.commit('applicationManagement/SET_TAB_NAME', e)
    },
    setFooter (e) {
      this.$store.commit('applicationManagement/SET_FOOTER', e)
    },
    setTelegramWelcomeMessage (e) {
      this.$store.commit('applicationManagement/SET_TELEGRAM_WELCOME_MESSAGE', e)
    },
    setApiDelegator(e) {
      this.$store.commit('applicationManagement/SET_API_DELEGATOR', e)
    },
    setApiIntegrationToken(e) {
      this.$store.commit('applicationManagement/SET_API_INTEGRATION_TOKEN', e)
    },
    setTelegramBotToken (e) {
      this.$store.commit('applicationManagement/SET_TELEGRAM_BOT_TOKEN', e)
    },
    setUsersCanSimultaneousSessions (e) {
      this.$store.commit('applicationManagement/SET_CAN_SIMULTANEOUS_SESSIONS', e)
    },
    setLogicalExclusion (e) {
      this.$store.commit('applicationManagement/SET_LOGICAL_EXCLUSION', e)
    },

    setTabName (e) {
      this.$store.commit('applicationManagement/SET_TAB_NAME_LOGIN', e)
    },
    setUsernameLabel(e) {
      this.$store.commit('applicationManagement/SET_USERNAME_LABEL', e)
    },
    setForgotLabel(e) {
      this.$store.commit('applicationManagement/SET_FORGOT_LABEL', e)
    },
    setForgotPasswordButtonLabel(e) {
      this.$store.commit('applicationManagement/SET_FORGOT_PASSWORD_BUTTON_LABEL', e)
    },
    setTitle(e) {
      this.$store.commit('applicationManagement/SET_TITLE', e)
    },
    setPasswordLabel(e) {
      this.$store.commit('applicationManagement/SET_PASSWORD_LABEL', e)
    },
    setForgotPasswordTitle(e) {
      this.$store.commit('applicationManagement/SET_FORGOT_PASSWORD_TITLE', e)
    },
    setSubtitle(e) {
      this.$store.commit('applicationManagement/SET_SUBTITLE', e)
    },
    setSubmitLabel(e) {
      this.$store.commit('applicationManagement/SET_SUBMIT_LABEL', e)
    },
    setForgotPasswordEmailLabel(e) {
      this.$store.commit('applicationManagement/SET_FORGOT_PASSWORD_EMAIL_LABEL', e)
    },
    setEmailProtocol (e) {
      this.$store.commit('applicationManagement/SET_EMAIL_PROTOCOL', e.id)
    },
    setEmailPort (e) {
      this.$store.commit('applicationManagement/SET_EMAIL_PORT', e)
    },
    setEmailFromName (e) {
      this.$store.commit('applicationManagement/SET_EMAIL_FROM_NAME', e)
    },
    setEmailHost (e) {
      this.$store.commit('applicationManagement/SET_EMAIL_FROM_HOST', e)
    },
    setEmailFromAddress (e) {
      this.$store.commit('applicationManagement/SET_EMAIL_FROM_ADDRESS', e)
    },
    setEmailUsername (e) {
      this.$store.commit('applicationManagement/SET_EMAIL_USERNAME', e)
    },
    setEmailPassword(e) {
      this.$store.commit('applicationManagement/SET_EMAIL_PASSWORD', e)
    },
    async fetch_application_data (userSession, appToken, apiUrl) {
      this.$vs.loading({type: 'default'})
      return await this.$store.dispatch('applicationManagement/fetchApplicationData', {userSession, appToken, apiUrl})
        .then((res) => {
          this.$vs.loading.close()
          const settings = {
            settings: {
              //General
              favicon: res['general']['favicon'],
              tabName: res['general']['web_tab_name'],
              simultaneousSessions: res['general']['users_can_simultaneous_sessions'],
              footer: res['general']['footer'],
              logicalExclusion: res['general']['logical_exclusion'],
              telegramBotToken: res['general']['telegram_bot_token'],
              telegramWelcomeMessage: res['general']['telegram_user_welcome_message'],
              usersCanSimultaneousSessions: res['general']['users_can_simultaneous_sessions'],
              maxLoggedInUsers: res['general']['max_logged_in_users'],
              maxNamedUsers: res['general']['max_named_users'],
              apiDelegator: res['general']['api_delegator'],
              apiIntegrationToken: res['general']['api_token'],

              //Login
              title: res['login']['title'],
              tabTitle: res['login']['tab_title'],
              subtitle: res['login']['subtitle'],
              usernameLabel: res['login']['username_label'],
              passwordLabel: res['login']['password_label'],
              submitButtonText: res['login']['submit_button_label'],
              forgotLabel: res['login']['forgot_label'],
              logo: res['login']['logo'],
              background: res['login']['background'],
              forgotPasswordTitle: res['login']['forgot_password_title'],
              forgotPasswordEmailLabel: res['login']['forgot_password_email_label'],
              forgotPasswordButtonLabel: res['login']['forgot_password_button_label'],
              cardLogo: res['login']['card_logo'],

              //outGoingLabel
              emailSenderDriverTypeId: res['outgoing_server']['email_sender_driver_type_id'],
              emailSenderHost: res['outgoing_server']['email_sender_host'],
              emailSenderPort: res['outgoing_server']['email_sender_port'],
              emailSenderFromName: res['outgoing_server']['email_sender_from_name'],
              emailSenderFromAddress: res['outgoing_server']['email_sender_from_address'],
              emailSenderUsername: res['outgoing_server']['email_sender_username'],
              emailSenderPassword: res['outgoing_server']['email_sender_password']
            }
          }
          this.$store.dispatch('applicationManagement/setApplicationData', settings['settings'])

          setTimeout(() => {


            this.generalData.favicon = this.$store.state.applicationManagement.settings.favicon
            this.generalData.tabTitle = this.$store.state.applicationManagement.settings.tabName
            this.generalData.footer = this.$store.state.applicationManagement.settings.footer
            this.generalData.telegramWelcomeMessage = this.$store.state.applicationManagement.settings.telegramWelcomeMessage
            this.generalData.telegramBotToken = this.$store.state.applicationManagement.settings.telegramBotToken
            this.generalData.simultaneousSessions = this.$store.state.applicationManagement.settings.simultaneousSessions
            this.generalData.logicalExclusion = this.$store.state.applicationManagement.settings.logicalExclusion
            this.generalData.apiDelegator = this.$store.state.applicationManagement.settings.apiDelegator
            this.generalData.apiIntegrationToken = this.$store.state.applicationManagement.settings.apiIntegrationToken

            this.loginData.backgroundImage = this.$store.state.applicationManagement.settings.background

            if(this.loginData.backgroundImage === null) {
              this.backgroundViewMode = false
            }
            this.loginData.cardImage = this.$store.state.applicationManagement.settings.cardLogo
            if(this.loginData.cardImage === null) {
              this.cardImageViewMode = false
            }
            this.loginData.cardLogo = this.$store.state.applicationManagement.settings.logo
            if(this.loginData.cardLogo === null) {
              this.cardLogoViewMode = false
            }
            this.loginData.tabName = this.$store.state.applicationManagement.settings.tabTitle
            this.loginData.title = this.$store.state.applicationManagement.settings.title
            this.loginData.subtitle = this.$store.state.applicationManagement.settings.subtitle
            this.loginData.usernameLabel = this.$store.state.applicationManagement.settings.usernameLabel
            this.loginData.passwordLabel = this.$store.state.applicationManagement.settings.passwordLabel
            this.loginData.submitLabel = this.$store.state.applicationManagement.settings.submitButtonText
            this.loginData.forgotLabel = this.$store.state.applicationManagement.settings.forgotLabel
            this.loginData.forgotPasswordTitle = this.$store.state.applicationManagement.settings.forgotPasswordTitle
            this.loginData.forgotPasswordEmailLabel = this.$store.state.applicationManagement.settings.forgotPasswordEmailLabel
            this.loginData.forgotPasswordButtonLabel = this.$store.state.applicationManagement.settings.forgotPasswordButtonLabel

            this.serverData.emailSenderDriverTypeId = this.driverOptions.find(x => x.id === this.$store.state.applicationManagement.settings.emailSenderDriverTypeId)
            this.serverData.emailSenderPort = this.$store.state.applicationManagement.settings.emailSenderPort
            this.serverData.emailSenderFromName = this.$store.state.applicationManagement.settings.emailSenderFromName
            this.serverData.emailSenderHost = this.$store.state.applicationManagement.settings.emailSenderHost
            this.serverData.emailSenderFromAddress = this.$store.state.applicationManagement.settings.emailSenderFromAddress
            this.serverData.emailSenderUsername = this.$store.state.applicationManagement.settings.emailSenderUsername
            this.serverData.emailSenderPassword = this.$store.state.applicationManagement.settings.emailSenderPassword
          }, 300)
          // this.user_data = res
        })
        .catch(err => {
          this.$vs.loading.close()
          if (err.response.status === 404) {
            this.user_not_found = true
            return
          }
          console.error(err)
        })
    }
  },
  async created () {
    // Register Module UserManagement Module
    if (!moduleApplicationManagement.isRegistered) {
      this.$store.registerModule('applicationManagement', moduleApplicationManagement)
      moduleApplicationManagement.isRegistered = true
    }
    await this.fetch_application_data(this.$store.state.auth.token, this.$store.state.auth.app_token, this.$store.state.auth.api_url)
  }
}

</script>
